import { useCallback } from "react";

import { Button } from "@/components/ui/buttons/button";
import { useBackAction } from "@/hooks/use-back-action";
import { useSPAContext } from "@/providers/spa-provider";
import { RouteNames } from "@/types/route-names";
import { DojoSandboxView } from "./dojo-sandbox-view";

/**
 * Dojo View - Training mode selection for PVP practice
 */
export const DojoView = () => {
  // For now, Dojo defaults directly to Sandbox mode
  return <DojoSandboxView />;

  /*
  const { setCurrentRoute, previousRoute } = useSPAContext();

  const handleBack = useCallback(() => {
    setCurrentRoute(previousRoute);
  }, [previousRoute, setCurrentRoute]);

  useBackAction(handleBack);

  const handleSelectTrainingMode = (mode: "cpu" | "sandbox") => {
    if (mode === "cpu") {
      setCurrentRoute(RouteNames.DOJO_TRAINING_CONFIG);
    }
    if (mode === "sandbox") {
      setCurrentRoute(RouteNames.DOJO_SANDBOX);
    }
  };

  return (
    <div className="relative flex flex-col bg-pk-night-1/90 backdrop-blur-md pb-24 w-full h-full overflow-y-auto">
      <div className="z-10 relative flex justify-between items-center mt-6 xs:mt-8">
        <div className="flex flex-col ml-4 p-2">
          <div className="relative">
            <h1 className="drop-shadow-lg font-black text-white text-3xl xs:text-4xl uppercase leading-none tracking-tight">
              DOJO
            </h1>
            <div className="bg-pk-red-1 mt-1 w-12 xs:w-16 h-1 skew-x-[-20deg]" />
          </div>
          <p className="mt-2 text-pk-gray-4 text-sm">Train your battle skills</p>
        </div>
      </div>

      <div className="z-10 relative flex flex-col gap-4 xs:gap-6 mx-auto px-4 pt-4 xs:pt-6 w-full max-w-md">
        <Button
          onClick={() => handleSelectTrainingMode("cpu")}
          variant="night"
          className="w-full"
        >
          <div className="shadow-xl p-[4px] rounded-xl transition-colors duration-300">
            <div className="relative flex justify-between items-center gap-4 xs:gap-8 px-4 xs:px-8 rounded-md h-16 xs:h-32 overflow-hidden">
              <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent transition-transform -translate-x-full group-hover:translate-x-full duration-300 ease-in-out" />

              <div className="z-10 relative flex flex-col items-start gap-1">
                <span className="drop-shadow-[3px_3px_0_rgba(0,0,0,0.8)] font-black text-white text-xl xs:text-4xl italic tracking-wider">
                  VS CPU
                </span>
                <div className="flex items-center gap-2">
                  <span className="bg-pk-red-1 shadow-cartoon-sm px-2 py-0.5 rounded-sm font-bold text-[10px] text-white uppercase tracking-wider">
                    PRACTICE
                  </span>
                  <span className="font-bold text-pk-gray-4 text-xs xs:text-sm uppercase tracking-widest">
                    Battle AI opponents
                  </span>
                </div>
              </div>

              <span className="drop-shadow-lg text-4xl xs:text-6xl">
                🤖
              </span>
            </div>
          </div>
        </Button>

        <Button
          onClick={() => handleSelectTrainingMode("sandbox")}
          variant="night"
          className="w-full"
        >
          <div className="shadow-xl p-[4px] rounded-xl transition-colors duration-300">
            <div className="relative flex justify-between items-center gap-4 xs:gap-8 px-4 xs:px-8 rounded-md h-16 xs:h-32 overflow-hidden">
              <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent transition-transform -translate-x-full group-hover:translate-x-full duration-300 ease-in-out" />

              <div className="z-10 relative flex flex-col items-start gap-1">
                <span className="drop-shadow-[3px_3px_0_rgba(0,0,0,0.8)] font-black text-white text-xl xs:text-4xl italic tracking-wider">
                  SANDBOX
                </span>
                <div className="flex items-center gap-2">
                  <span className="bg-pk-yellow-1 shadow-cartoon-sm px-2 py-0.5 rounded-sm font-bold text-[10px] text-pk-night-1 uppercase tracking-wider">
                    SKILL TEST
                  </span>
                  <span className="font-bold text-pk-gray-4 text-xs xs:text-sm uppercase tracking-widest">
                    Test attacks on a dummy
                  </span>
                </div>
              </div>

              <span className="drop-shadow-lg text-4xl xs:text-6xl">🧪</span>
            </div>
          </div>
        </Button>
      </div>
    </div>
  );
  */
};
